<script setup lang="ts">
import { PhBookOpenText, PhHeadphones, PhAtom, PhSparkle } from '@phosphor-icons/vue'
import { onMounted, onBeforeUnmount, ref } from 'vue'

const section = ref<HTMLElement>()
const visible = ref(false)
let observer: IntersectionObserver | undefined
onMounted(() => {
  observer = new IntersectionObserver(([entry]) => {
    visible.value = !!entry?.isIntersecting
  })
  if (section.value) observer.observe(section.value)
})
onBeforeUnmount(() => observer?.disconnect())
</script>

<template>
  <section
    ref="section"
    id="encyclopedia"
    class="encyclopedia-intro section"
    :class="{ 'in-view': visible }"
  >
    <div class="container encyclopedia-inner">
      <div class="encyclopedia-copy">
        <span class="feature-label"><PhBookOpenText :size="20" /> 实验百科</span>
        <h2>从一个“为什么”，<br />发现科学的另一面。</h2>
        <p>读科学，听知识，解锁身边的奥秘。</p>
        <div class="encyclopedia-benefits">
          <span><PhBookOpenText :size="20" /> 图文讲解</span>
          <span><PhHeadphones :size="20" /> 有声探索</span>
        </div>
      </div>
      <div class="knowledge-visual" aria-label="用阅读和聆听探索科学知识">
        <div class="knowledge-orbit" aria-hidden="true"></div>
        <div class="knowledge-note note-back" aria-hidden="true">
          <PhAtom :size="64" weight="duotone" /><span>保持好奇，继续探索</span>
        </div>
        <div class="knowledge-note note-front">
          <PhSparkle :size="28" weight="duotone" />
          <span class="knowledge-kicker">把好奇心，变成新知识</span>
          <p>看见现象<br /><em>读懂原理</em></p>
          <div class="knowledge-wave" aria-hidden="true">
            <i
              v-for="n in 20"
              :key="n"
              :style="{ '--i': n, height: `${12 + ((n * 17) % 34)}px` }"
            ></i>
          </div>
          <span class="knowledge-caption"><PhHeadphones :size="16" /> 阅读，也可以聆听</span>
        </div>
      </div>
    </div>
  </section>
</template>
